import Vue from 'vue';
import moment from 'moment';
import Activity from '../lib/Activity';

export default {
  state: {
    members: {},
  },
  mutations: {
    addArchivedActivities(state, payload) {
      if (!state.members[payload.memberId]) {
        Vue.set(state.members, payload.memberId, []);
      }
      state.members[payload.memberId].push(...payload.archivedActivities);
    },
    clearArchivedActivities(state, payload) {
      if (payload && payload.memberId) {
        if (state.members[payload.memberId]) {
          state.members[payload.memberId].length = 0;
        }
      } else {
        // remove everything
        state.members = {};
      }
    },
  },
  getters: {
    archivedActivitiesByMemberId: state => (memberId) => {
      if (!state.members[memberId]) {
        return [];
      }

      return state.members[memberId].map(activity => new Activity(activity));
    },
    archivedActivityByMemberIdAndActivityId: state => (memberId, activityId) => {
      if (!state.members[memberId]) {
        return null;
      }

      return state.members[memberId]
        .find(activity => activity.activity_id === activityId);
    },
    archivedActivitiesByMemberIdAndDate: state => (memberId, momentDate) => {
      if (!state.members[memberId]) {
        return [];
      }

      const format = 'YYYY-MM-DD';

      return state.members[memberId]
        .filter(
          activity => moment(activity.local_start_time).format(format)
            === momentDate.format(format),
        );
    },
  },
  actions: {
    async loadArchivedActivities(
      { commit, getters },
      {
        memberId,
        months,
        useCachedValues,
        cognitoId,
        all,
      },
    ) {
      if (useCachedValues) {
        const currentArchivedActivities = getters.archivedActivitiesByMemberId(memberId);
        if (currentArchivedActivities && currentArchivedActivities.length) {
          return;
        }
      }

      const flaggedAsDuplicateSince = moment().subtract(months, 'months').format('YYYY-MM-DD');
      // Use tomorrow as the end date so that we include all archivedActivities from today
      const res = await this.$container.dao.getActivities(
        memberId,
        null,
        null,
        null,
        cognitoId,
        flaggedAsDuplicateSince,
        all,
      );

      let archivedActivities = res.data.activities;

      if (typeof archivedActivities === 'undefined') {
        commit('clearArchivedActivities', { memberId });
        throw new Error('Undefined response from getArchivedActivities');
      }

      archivedActivities = archivedActivities.map(activity => new Activity(activity));

      commit('clearArchivedActivities', { memberId });
      commit('addArchivedActivities', { memberId, archivedActivities });
    },
    clearArchivedActivities(context, payload) {
      context.commit('clearArchivedActivities', payload);
    },
  },
};
